export const WidgetConstants = {
    WIDGET_HELP_CENTER_HAS_SESSION: 'widgetHelpCenterHasSession',
    SHOW_WIDGET: 'showWidget',
    BLIP_CHAT_SHOW_CLOSE_BUTTON: 'ShowCloseButton',
};
export const WidgetConstantsTracks = {
    HELPBUILDER_WIDGET_CHAT_OPEN: 'helpbuilder-widget-chat-open',
    HELPBUILDER_WIDGET_BLIP: 'helpbuilder-widget-blip',
    HELPBUILDER_WIDGET_CHAT_CLOSE: 'helpbuilder-widget-chat-close',
};
